import React from 'react';
import PropTypes from 'prop-types';

import {
  Chip, Menu, MenuItem, Stack, Typography, Box, TextField, Button,
} from 'views/components';
import {FilterList, ChevronRight} from 'views/icons';
import {translate, FilterMenuPopover, FilterOptions} from 'views/module';

const FilterOption = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(null);
  const [searchText, setSearchText] = React.useState('');

  const updateFilter = props.updateFilter;
  const filterOptions = props.filterOptions;

  const clearPopover = () => {
    setAnchorEl(null);
    setOpen(null);
    setSearchText('');
  };

  const handleClick = (filter, item) => {
    updateFilter(filter, item);

    clearPopover();
  };

  const sortedFilter = Object.values(filterOptions)
      .sort((a, b) => {
        // If both items have a rank, compare them by rank
        return a.rank - b.rank;
      });

  return (
    <>
      <Box sx={{p: 0.5}} >
        <Chip
          icon={<FilterList />}
          color="primary"
          label={`${translate('generic.AddFilter')}`}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        />
      </Box>
      {
        anchorEl &&
        <Menu
          anchorEl={anchorEl}
          anchorReference="anchorPosition"
          anchorPosition={{
            top: anchorEl.getBoundingClientRect().bottom + 12,
            left: anchorEl.getBoundingClientRect().left,
          }}
          open={Boolean(anchorEl)}
          onClose={(e) => clearPopover()}
          slotProps={{
            paper: {
              sx: {minWidth: '150px'},
            },
          }}
        >
          {
            sortedFilter.map((filter) => {
              const key = filter.key;
              const label = filter.label;

              return (
                <MenuItem
                  key={key}
                  sx={{pr: 1}}
                  onMouseOver={() => setOpen(filter)}
                >
                  <Stack direction={'row'} width={'100%'} justifyContent={'space-between'}>
                    <Typography>
                      {label}
                    </Typography>
                    <ChevronRight sx={{color: 'grey.500'}}/>
                  </Stack>
                </MenuItem>
              );
            })
          }
        </Menu>
      }
      {
        open &&
        <FilterMenuPopover
          anchorEl={anchorEl}
          anchorPositionTop={anchorEl.getBoundingClientRect().bottom + 12}
          anchorPositionLeft={anchorEl.getBoundingClientRect().right + 55}
          sx={{pointerEvents: 'none'}}
          display={
            open.type === 'text' ?
            <Box sx={{pointerEvents: 'auto', p: 1}}>
              <Typography variant="subtitle2" sx={{mb: 1, fontWeight: 'bold'}}>
                {open.label}
              </Typography>
              <Stack
                component="form"
                direction="row"
                spacing={1}
                onSubmit={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleClick(open, {key: searchText, label: searchText});
                }}
              >
                <TextField
                  autoFocus
                  size="small"
                  placeholder={translate('client.ClientList.Filter.SearchPlaceholder')}
                  value={searchText}
                  onChange={(val) => setSearchText(val)}
                  onKeyDown={(e) => e.stopPropagation()}
                />
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!searchText}
                >
                  {translate('client.ClientList.Filter.Search')}
                </Button>
              </Stack>
            </Box> :
            <FilterOptions
              filter={open}
              onClick={handleClick}
              filterKey={open}
            />
          }
        />
      }
    </>
  );
};

FilterOption.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  filterOptions: PropTypes.object.isRequired,
};


export default React.memo(FilterOption);
